import React from 'react';
import { Link } from 'react-router-dom';
import { PD_URL } from '../../config/constants';

const Topbar = () => {
  return (
    <div className="topbar">
      <div className="container topbar__inner">
        <div className="topbar__left">
          <a href={PD_URL} target="_blank" rel="noopener noreferrer">
            Partito Democratico
          </a>
          <span className="topbar__separator"></span>
          <span>L'organizzazione giovanile del PD</span>
        </div>
        <div className="topbar__right hide-mobile">
          <Link to="/stampa">Area Stampa</Link>
          <span className="topbar__separator"></span>
          <Link to="/contatti">Contatti</Link>
          <span className="topbar__separator"></span>
          <Link to="/faq">FAQ</Link>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
